import { render, staticRenderFns } from "./K12NetRedirect.vue?vue&type=template&id=9e4f1b5c&scoped=true"
import script from "./K12NetRedirect.vue?vue&type=script&lang=js"
export * from "./K12NetRedirect.vue?vue&type=script&lang=js"
import style0 from "./K12NetRedirect.vue?vue&type=style&index=0&id=9e4f1b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4f1b5c",
  null
  
)

export default component.exports